import React, { useState } from "react";
import { negativeNumberStringValidation } from "../Utils/validation";

interface Props {
  //   onChange: (otp: string) => void;
  img: any;
  label: string;
  name: string;
  first: string;
  second: string;
  third: string;
  handleChange: any;
  onBlur: any;
  validation: any;
  items: any
}



const MultitextBox = (props) => {
  const { img, label, name, first, second, third, handleChange, onBlur, validation, items,view } = props;
  const [error, setError] = useState([]);

  const [otp, setOtp] = useState<string[]>(new Array(3).fill(""));
  let names = [first, second, third]


  const handleOtpChange = (index: number, value: string) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

  };


  const onBlurEnd = (event) => {
    // if (!error.includes(event.target.name) && event.target.value.trim().length !== 0) {
    //   onBlur(event)
    // }
  }

  const onChangeEnd = (event) => {
    // setError(false);
    let errorDublicate = [...error]
    if (validation === "children")
      if (event.target.value.trim().length !== 0)
        if (!negativeNumberStringValidation(event.target.value)) {
          errorDublicate = [...errorDublicate, event.target.name]
        }
        else {
          errorDublicate = errorDublicate.filter(item => item !== event.target.name)
        }
    setError(errorDublicate)
    handleChange(event, !errorDublicate.includes(event.target.name))
  }


  return (
    <div>
      {otp.map((digit, index) => (
        <input
          key={index}
          type="text"
          name={names[index]}
          maxLength={2}
          disabled={view}
          value={props[names[index]]}
          onChange={onChangeEnd}
          className={`multi-text ${(error.includes(names[index])) && 'errorAlert'}`}

          onBlur={onBlurEnd}
        />
      ))}
      <span className="det-label">{label}</span>
      <input defaultValue={0} onBlur={onBlur} type="number" disabled={view}
        {...(name === "children" ? {
          onInput: (e) => {
            e.target['value'] = Math.abs(e.target['value']);
            let value = parseInt(e.target['value']);
            if (value > 3) {
              value = 3;
            } else if (isNaN(value)) {
              value = 0;
            }
            e.target['value'] = value;
          }
        } : {})} value={props[name]} name={name} min={0}  max={name === "children" && 3} onChange={handleChange} className="number-custom" />
    </div>
  );
};

export default React.memo(MultitextBox);
